<div app-landing-page-section-container class="items-center pb-5 lg:pb-10">
    <div class="mat-headline-6 text-center pb-4">FAQ</div>

    <div class="mt-4 md:mt-8">
        @for (faq of faqs; track faq; let last = $last) {
            <div
                class="bg-white w-full first:rounded-t-2xl last:rounded-b-2xl last:no-border"
            >
                <app-expandable
                    [showBorderBottom]="!last"
                    [showIndicator]="true"
                >
                    <div expandable-head class="expandable-head">
                        {{ faq.question | translate }}
                    </div>
                    <div
                        expandable-body
                        [innerHTML]="faq.answer | translate"
                    ></div>
                </app-expandable>
            </div>
        }
    </div>
</div>
